import { STOP_PRODUCT } from "@/common/constant";
import { PRODUCT_STATUS } from "./product";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const noimage = require("@/assets/images/muuq-base/noimage.png");

export class CartItemList {
  list = [];

  push(item) {
    this.list.push(new CartItem(item));
  }

  get quanlity() {
    /* eslint-disable unicorn/no-array-reduce */
    return this.list.reduce((memo, item) => {
      return memo + (item.item.cart_quanlity - 0);
    }, 0);
  }
  get total() {
    /* eslint-disable unicorn/no-array-reduce */
    return this.list.reduce((memo, item) => {
      return memo + (item.item.price - 0) * item.item.cart_quanlity;
    }, 0);
  }

  get hasPipeItem() {
    return this.pipeItems().length > 0;
  }

  pipeItems(): any[] {
    return this.list.filter(({ item }) => {
      return item.master_product && item.master_product.postage_identification_kbn == '2';
    });
  }
}
export default class CartItem {
  item: any;
  
  constructor(dto) {
    this.item = dto;
  }

  get statusName() {
    // 取消 remove
    return this.item.status;
  }

  get salesName() {
    // 取消 remove
    // sales_judge_kbn
    if (this.item.product && this.item.master_product) {
      if (this.item.product.status === PRODUCT_STATUS.inActive) {
        return 'off';
      } else if (STOP_PRODUCT.includes(this.item.master_product.sales_judge_kbn + "")) {
        return 'stop';
      }
    }
    return "";
  }
  
  get itemName() {
    if (this.item.set_item_code) {
      return this.item.set_item_name_1;
    }
    return this.item.master_product ? this.item.master_product.item_name_1 : '';
  }

  get itemName2() {
    if (this.item.set_item_code) {
      return this.item.set_item_name_2;
    }
    return this.item.master_product ? this.item.master_product.item_name_2 : '';
  }

  get itemCode() {
    if (this.item.set_item_code) {
      return this.item.set_item_code;
    }
    return this.item.item_code;
  }

  get categoryName() {
    if (this.item.set_item_code) {
      return this.item.product.cateName;
    }
    return this.item.cateName;
  }

  get unitName() {
    if (this.item.set_item_code) {
      return this.item.unitName;
    }
    return "1" + this.item.master_product.unit;
  }

  get unit() {
    if (this.item.set_item_code) {
      return this.item.set_unit;
    }
    return this.item.master_product ? this.item.master_product.unit : '';
  }

  get sPipe() {
    if (this.item.set_item_code) {
      return this.item.product.master_product.postage_identification_kbn;
    }
    return this.item.master_product.postage_identification_kbn;
  }

  get imageUrl() {
    if (this.item.set_item_code) {
      return this.item.product.imageUrl;
    }
    return this.item.imageUrl;
  }

  get imageUrlByCart() {
    if (this.item.original_url) {
      return this.item.original_url;
    }

    return noimage;
  }

  get orreUnitPrice() {
    if (this.item.set_item_code) {
      return this.item.set_price;
    }

    return this.item.orre_unit_price;
  }

  get getQuantity() {
    if (this.item.set_item_code) {
      return (
        this.item.set_unit +
        "（" +
        this.item.quantity_per_carton +
        this.item.unit +
        "入り）"
      );
    }

    return this.item.unit;
  }

  get getOrderQuantity() {
    if (this.item.set_item_code) {
      return this.item.set_quantity;
    }

    return this.item.orre_quantity;
  }

  get getOrderUnit() {
    if (this.item.set_item_code) {
      return this.item.set_unit;
    }

    return this.item.unit;
  }

  get subTotal() {
    if (this.item.set_item_code) {
      return this.item.set_quantity * this.item.set_price + this.item.set_unit;
    }

    return this.item.orre_unit_price + this.item.orre_quantity;
  }

  get piKbnProduct() {
    if (!this.item.master_product) return "";
    return this.item.master_product.postage_identification_kbn;
  }
}
